import React from 'react'
import {Link} from 'react-router-dom'

const Support = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }
    return(
        <section className="wpo-support-section">
            <div className="container">
                <div className="wpo-support-wrapper">
                    <div className="wpo-support-text">
                        <h2>Build. Launch. Grow.</h2>
                        <p>Work with a team that delivers powerful websites, custom software, and performance-driven marketing that elevates your brand.</p>
                    </div>
                    <div className="wpo-support-btn">
                        <Link onClick={ClickHandler} to="/contact"> Schedule a Free Call</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Support;